import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import {
    QueryParamProvider,
    transformSearchStringJsonSafe,
} from 'use-query-params';
import Router from './RouterSelect';
import { SiteHeader } from './SiteHeader/SiteHeader';
import MandalaSkeleton from '../views/common/MandalaSkeleton';
import { MandalaSession } from './MandalaSession';
import { getDictionaryOrder } from '../views/Terms/TermDictionaries/TermDictionaries';
import { useDictionaryStore } from '../hooks/useDictionaryStore';
const ContentMain = lazy(() => import('./ContentMain'));
const stringifyOptions = {
    transformSearchString: transformSearchStringJsonSafe,
};

export function Main(props) {
    // Set up cookies etc.
    MandalaSession();

    // Load Dictionary info for terms into app store
    const { setDictInfo } = useDictionaryStore();
    useEffect(() => {
        getDictionaryOrder().then((data) => {
            setDictInfo(data);
        });
        // Set user view setting defaults in case it hasn't been saved yet (See ViewSettings.js)
        if (localStorage.getItem('savedViewSettings') !== 'true') {
            localStorage.setItem('savedViewSettings', 'true');
            localStorage.setItem(
                'userViewSettings',
                '{"places":"69|roman.popular","subjects":"72|roman.popular","terms":"75|pri.orig.sec.roman"}'
            );
        }
    }, []);

    // Hash Router: Display page depending on hash path
    return (
        <Router
            {...(process.env.REACT_APP_STANDALONE !== 'standalone'
                ? { basename: '/' }
                : {})}
        >
            <QueryParamProvider
                ReactRouterRoute={Route}
                stringifyOptions={stringifyOptions}
            >
                <div id={'l-site__wrap'} className={`l-site__wrap`}>
                    {/* <HistoryListener /> */}
                    <SiteHeader />
                    {/* <Hamburger hamburgerOpen={false} /> */}
                    {/** TODO:gk3k -> Need to set a proper loading component with Skeletons */}
                    <Suspense fallback={<MandalaSkeleton overlay={true} />}>
                        <Switch>
                            {/*
                            <Route path={'/home'}>
                                <Home />
                            </Route>

                            {process.env.REACT_APP_STANDALONE !==
                                'standalone' && (
                                <Route exact path={'/'}>
                                    <Redirect to={'/home'} />
                                </Route>
                            )}
                            */}
                            <Route path={'*'}>
                                <ContentMain
                                    site={'mandala'}
                                    mode={'development'}
                                    title={'Mandala'}
                                    sui={props.sui}
                                />
                            </Route>
                            {/*
                            <Route path={'*'}>
                                <NotFoundPage />
                                <Home />
                            </Route>

                            */}
                        </Switch>
                    </Suspense>

                    {/* <Hamburger hamburgerOpen={false} /> */}
                </div>
            </QueryParamProvider>
        </Router>
    );
}
